import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { COLOR_NAME, ORDER_METHOD, PARAMS_NAME } from '../constants'
import paths from '../routes/paths'
import qs from 'query-string'

import DynamicColor from '../components/common/dynamic-color'
import ModalForm from '../components/common/modal-form'
import Button from '../components/elements/Button'

const ModalExpireTime = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const { pathname, search } = history.location
    const [showModal, setShowModal] = useState(false)
    const { orderMethod, expireTime } = useSelector(state => state.OrderReducer)

    const handleClose = () => {
        setShowModal(false)
        history.push({
            pathname: paths.notFound,
            state: {
                message: t('modalExpireOrderSession.message'),
            },
        })
    }

    const isExcludesPath = () => {
        return (
            pathname.includes(paths.notFound) ||
            pathname.includes(paths.unSupport)
        )
    }

    const validContext = () => {
        const params = qs.parse(search)
        return (
            !pathname.includes(paths.notFound) &&
            !pathname.includes(paths.unSupport) &&
            !params[PARAMS_NAME.ORDER_GO_ID] &&
            !params[PARAMS_NAME.ORDER_WEB_ID]
        )
    }

    useEffect(() => {
        let timeOut

        if (!validContext()) {
            timeOut && clearTimeout(timeOut)
            return setShowModal(false)
        }

        if (
            validContext() &&
            [ORDER_METHOD.QR_CODE, ORDER_METHOD.TABLE_QRCODE].includes(
                orderMethod
            ) &&
            expireTime
        ) {
            const deltaTime = expireTime - new Date().getTime()
            console.log('addtimeout ---------------')

            timeOut = setTimeout(() => {
                setShowModal(true)
            }, Math.max(0, deltaTime))
        }

        return () => {
            console.log('clear-addtimeout ---------------')
            timeOut && clearTimeout(timeOut)
        }
    }, [expireTime, orderMethod, pathname, search])

    return (
        <ModalForm isOpen={showModal} centered contentClass="p-3">
            <div className="text-center heading-5">
                {t('modalExpireOrderSession.title')}
            </div>

            <DynamicColor
                style={{ color: COLOR_NAME.MODAL_TEXT }}
                className="label-1 text-center mt-3"
            >
                {t('modalExpireOrderSession.message')}
            </DynamicColor>

            <div className="text-right mt-4 text-center">
                <Button onClick={handleClose}>
                    {t('modalExpireOrderSession.btnAgree')}
                </Button>
            </div>
        </ModalForm>
    )
}

export default ModalExpireTime
